﻿// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant Detail component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var MainContent = require('share/components/layout/Izenda.MainContent');
  var Tabs = require('share/components/controls/Izenda.Tab').Tabs;
  var Tab = require('share/components/controls/Izenda.Tab').Tab;
  var Panel = require('share/components/controls/Izenda.Panel');
  var Alert = require('share/components/controls/Izenda.Alert');
  var CommonMessages = require('share/messages/Izenda.CommonMessages');
  var connect = require('share/enhancers/Izenda.Connect');
  var TenantDetailTab = require('./Izenda.TenantDetailTab');
  var Permissions = require('../PermissionTab/Izenda.Permissions');
  const { isEmpty } = require('lodash/fp');
  var Header = observer(function(props) {
    var store = props.store;
    var disabled = !store.showingTenantCloned.active;
    var localization = props.localization;
    var authorization = props.authorization;
    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
    var hasEditPrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsEdit]);
    var hasCreatePrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsCreate]);

    function onAuth() {
      return {
        disabled: true
      };
    }

    return (
      <section className='izenda-Wrapper-header'>
        <IconMenu />

        <div className='izenda-Alert-container'>
          <Alert type={store.alertMessage.type}>{store.alertMessage.message}</Alert>
        </div>

        {(hasEditPrivilege || hasCreatePrivilege) && (
          <fieldset className='pull-right' disabled={disabled}>
            <button className='btn btn-primary' onClick={props.onSave} disabled={disabled}>
              {localization.getText('COMMON_LABEL_SAVE')}
            </button>
            <button className='btn btn-primary u_marginLeft' onClick={props.onCancel} disabled={disabled}>
              {localization.getText('COMMON_LABEL_CANCEL')}
            </button>
          </fieldset>
        )}
      </section>
    );
  });

  var TenantDetail = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      this.props.store.init();
      this.cloneTenantDetail();
    },

    componentWillReceiveProps: function() {
      this.props.validation.reset();
      this.cloneTenantDetail();
    },

    componentWillUnmount: function() {
      this.props.store.destroy();
    },

    /**
     * Clone the tenant detail
     */
    cloneTenantDetail: function() {
      this.props.store.cloneTenantDetail();
    },

    /**
     * Save Tenant
     */
    onSave: function() {
      var props = this.props;
      var store = props.store;
      var localization = this.props.localization;

      var valManager = props.validation;
      var confirmFn = props.confirmFn;

      store.alertMessage = CommonMessages.EMPTY_MESSAGE; // reset alert message

      valManager
        .validate()
        .bind(this)
        .then(function(success) {
          if (success && !store.showingTenantCloned.hasDirty) {
            store.setAlertMessage('info', localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
          } else if (success) {
            store
              .validateAccesses()
              .bind(this)
              .then(function(result) {
                if (result.success !== false) {
                  confirmFn('Confirmation', {
                    description: store.getBundle().MESSAGE.SAVE
                  })
                    .bind(this)
                    .then(function() {
                      return success && this.saveTenant();
                    });
                } else {
                  this.props.validation.updateErrors(result.messages);
                }
              });
          }
        });
    },

    /**
     * save Tenant
     */
    saveTenant: function() {
      var valManager = this.props.validation;
      var props = this.props;
      var loader = props.loader;

      loader.startLoading();

      return this.props.store
        .saveTenant()
        .then(updateErrorIfAny)
        .finally(loader.endLoading.bind(loader));

      function updateErrorIfAny(errors) {
        if (!isEmpty(errors)) {
          valManager.updateErrors(errors);
        }
        return null;
      }
    },

    /**
     * Cancel all modification
     */
    onCancel: function() {
      var store = this.props.store;
      var confirmFn = this.props.confirmFn;
      var currentTenant = store.showingTenant;
      store.alertMessage = CommonMessages.EMPTY_MESSAGE; // reset alert message
      if (store.showingTenantCloned.hasDirty) {
        confirmFn('Confirmation', {
          description: store.getBundle().MESSAGE.CANCEL
        }).then(
          function() {
            this.props.validation.reset();
            store.loadTenant(currentTenant);
          }.bind(this)
        );
      }
    },

    /**
     * Validation before change tabs
     * @return {object} promise
     */
    validationBeforChangeTabs: function() {
      var props = this.props;
      var store = props.store;
      return props.validation
        .validate()
        .bind(this)
        .then(function(success) {
          if (success) {
            return store
              .validateAccesses()
              .bind(this)
              .then(function(result) {
                if (result.success === false) {
                  return this.props.validation.updateErrors(result.messages);
                } else {
                  return Promise.resolve(true);
                }
              });
          }
        });
    },

    render: function() {
      var store = this.props.store;
      var disabled = !store.showingTenantCloned.active;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var permissionKeys = this.props.authorizationConstants.PERMISSION_KEY;
      var hasPermissionTabPrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupPermissionsValue]);

      return (
        <MainContent>
          <div className='izenda-Wrapper'>
            <Header {...this.props} onSave={this.onSave} onCancel={this.onCancel} />

            {/* tenant details */}

            <div className='izenda-Wrapper-content u_paddingLeftRight'>
              <Panel className='panel-header-custom u_fullHeight u-posRelative'>
                <Tabs activeTabKey='details' canChangeTab={this.validationBeforChangeTabs}>
                  <Tab title={localization.getText('COMMON_LABEL_DETAILS')} tabKey='details'>
                    <TenantDetailTab store={store} showingTenant={store.showingTenantCloned} />
                  </Tab>
                  {hasPermissionTabPrivilege ? (
                    <Tab title={localization.getText('COMMON_LABEL_PERMISSIONS')} tabKey='permissions'>
                      <Permissions
                        permissionStore={store.permissionStore}
                        disabledTab={disabled}
                        accessStore={store.accessStore}
                      />
                    </Tab>
                  ) : null}
                </Tabs>
              </Panel>
            </div>
          </div>
        </MainContent>
      );
    }
  });

  module.exports = connect()(TenantDetail);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/TenantManagement/Izenda.TenantDetail.jsx